/* KL kolekcja v2 - DEMO 27.10.2026 (tylko kopia motywu "KL demo kolekcja v2 27.10").
   1) przelacznik ukladu filtrow: boczne <-> poziome (E, komputer, przyklejone),
   2) liczba kolumn (C): komputer 3/4/5, telefon 1/2,
   3) kafel doradcy: komputer = 1. kafel 2. rzedu, telefon = blok F na cala szerokosc po 3 rzedach,
   4) Porownaj modele (F): checkbox na kaflu, pasek "Porownaj (n/4)", okno z parametrami (/products/<h>?view=kl-porownaj),
   5) ?tlo=1 / ?tlo=0 - tlo zdjec jak w wyszukiwarce (klasa ustawiana juz w kl-kv2-gora.liquid).
   Motyw przerysowuje sekcje przy filtrowaniu - wszystko jest idempotentne i odpalane po zmianach DOM (rAF). */
(function () {
  if (window.klKv2) return;
  window.klKv2 = true;
  var H = document.documentElement;
  var mqD = window.matchMedia('(min-width: 990px)');
  var mqM = window.matchMedia('(max-width: 749px)');
  var LS = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} },
  };
  /* runda 8 (03.11): zapis tekstu TYLKO gdy inny - zwykle textContent= podmienia wezel tekstowy (mutacja childList),
     MutationObserver ponizej planowal wtedy kolejny przebieg i strona wpadala w petle co klatke (60/s).
     Skutek: requestIdleCallback nigdy nie dostawal wolnej chwili, a motyw czeka na niego przed filtrowaniem
     (startViewTransition 'product-grid') - URL sie zmienial, siatka i zapytanie section_id nie szly. */
  function tekst(el, t) { if (el && el.textContent !== t) el.textContent = t; }
  function html(el, h) { if (el && el.dataset.kv2Html !== h) { el.dataset.kv2Html = h; el.innerHTML = h; } }
  var status = function (t) { var s = document.querySelector('[data-kv2-status]'); if (s) s.textContent = t; };

  /* ---------- stan ---------- */
  function uklad() { return LS.get('kv2-filtry') === 'poziome' ? 'poziome' : 'boczne'; }
  function kolD() {
    // user 27.10: filtry z boku = 3 lub 4 kolumny, filtry u gory = 3, 4 lub 5
    // runda 3: osobny wybor dla kazdego ukladu, domyslnie 3 z boku i 4 u gory
    var poz = uklad() === 'poziome';
    var k = Number(LS.get(poz ? 'kv2-kol-gora' : 'kv2-kol-bok'));
    if (!(k >= 3 && k <= (poz ? 5 : 4))) k = poz ? 4 : 3;
    return k;
  }
  function kolM() { var k = Number(LS.get('kv2-kol-m')); return k === 1 || k === 2 ? k : 2; }
  function zastosujStan() {
    H.classList.toggle('kv2-fh', uklad() === 'poziome' && mqD.matches);
    H.style.setProperty('--kv2-kol', kolD());
    H.style.setProperty('--kv2-kol-m', kolM());
    H.classList.toggle('kv2-m1', kolM() === 1);   // 04.11.2026: przelacznik swiatla na telefonie tylko w 1 kolumnie
  }

  /* ---------- wysokosc naglowka (przyklejony pasek filtrow) ---------- */
  /* runda 6: przyklejony pasek filtrow idzie POD widocznym naglowkiem sklepu. Naglowek KL chowa sie przy
     przewijaniu w dol i wysuwa przy przewijaniu w gore (sticky=scroll-up) - liczymy jego aktualna dolna krawedz
     klatka po klatce (scroll + kilkaset ms animacji po zmianie stanu), wiec pasek jedzie razem z nim, bez skoku. */
  var naglowek = null, animDo = 0, czekaTop = false;
  function liczTop() {
    naglowek = naglowek && naglowek.isConnected ? naglowek : document.querySelector('header-component');
    var dol = 0;
    if (naglowek) {
      var r = naglowek.getBoundingClientRect();
      if (r.bottom > 0 && r.height > 0) dol = Math.round(r.bottom);
    }
    H.style.setProperty('--kv2-top', dol + 'px');
    H.classList.toggle('kv2-hdr-widoczny', dol > 0);
  }
  function liczTopRaf() {
    if (czekaTop) return;
    czekaTop = true;
    requestAnimationFrame(function () { czekaTop = false; liczTop(); if (performance.now() < animDo) liczTopRaf(); });
  }
  function sledzNaglowek() {
    var h = document.querySelector('header-component');
    if (!h || h.dataset.kv2Obs) return;
    h.dataset.kv2Obs = '1';
    new MutationObserver(function () { animDo = performance.now() + 600; liczTopRaf(); })
      .observe(h, { attributes: true, attributeFilter: ['data-sticky-state', 'data-scroll-direction', 'class', 'style'] });
  }

  /* ---------- pasek narzedzi ---------- */
  var IK = {
    boczne: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><rect x="3" y="4" width="6" height="16" rx="1"/><path d="M12 6h9M12 12h9M12 18h9"/></svg>',
    poziome: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><rect x="3" y="3" width="18" height="5" rx="1"/><path d="M4 12h16M4 16h16M4 20h16"/></svg>',
  };
  function ikKol(n) {
    var w = 18, g = 1.5, s = (w - g * (n - 1)) / n, r = '';
    for (var i = 0; i < n; i++) r += '<rect x="' + (3 + i * (s + g)).toFixed(2) + '" y="3" width="' + s.toFixed(2) + '" height="18" rx="0.8"/>';
    return '<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' + r + '</svg>';
  }
  function zbudujPasek() {
    var pasek = document.querySelector('.collection-wrapper .facets--horizontal');
    if (pasek && !pasek.querySelector('.kv2-tb')) {
      var tb = document.createElement('div');
      tb.className = 'kv2-tb';
      tb.innerHTML =
        '<div class="kv2-seg kv2-seg--uklad" role="group" aria-label="Układ filtrów"><span class="kv2-seg__l">Filtry</span>' +
        '<button type="button" data-kv2-uklad="boczne">' + IK.boczne + 'Z boku</button>' +
        '<button type="button" data-kv2-uklad="poziome">' + IK.poziome + 'U góry</button></div>' +
        '<div class="kv2-seg kv2-seg--kol" role="group" aria-label="Liczba kolumn">' +
        [3, 4, 5].map(function (n) { return '<button type="button" data-kv2-kol="' + n + '" aria-label="' + n + ' kolumny" title="' + n + ' w rzędzie">' + ikKol(n) + '</button>'; }).join('') +
        '</div>';
      pasek.insertBefore(tb, pasek.firstChild);
    }
    // telefon (MOBILE D): przyklejony pasek "Filtry (n)" + "Sortuj" + 1/2 kolumny; przycisk motywu zostaje ukryty i jest wywolywany
    var tgl = document.querySelector('.collection-wrapper .facets-toggle');
    if (tgl && !tgl.querySelector('.kv2-mbar')) {
      var nFil = 0;
      new URLSearchParams(location.search).forEach(function (v, k) { if (k.indexOf('filter.') === 0 && !/price\.(gte|lte)$/.test(k)) nFil++; });
      if (/filter\.v\.price/.test(location.search)) nFil++;
      var sel = document.querySelector('.collection-wrapper select.sorting-filter__select');
      var opcje = sel ? Array.prototype.slice.call(sel.options).map(function (o) { return '<option value="' + o.value + '"' + (o.selected ? ' selected' : '') + '>' + o.textContent.trim() + '</option>'; }).join('') : '';
      var mb = document.createElement('div');
      mb.className = 'kv2-mbar';
      mb.innerHTML =
        '<button type="button" class="kv2-mbar__b" data-kv2-mfiltry><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M4 6h16M7 12h10M10 18h4"/></svg>Filtry' + (nFil ? ' <small>' + nFil + '</small>' : '') + '</button>' +
        (opcje ? '<label class="kv2-mbar__b kv2-mbar__sort"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M7 4v16M3 16l4 4 4-4M17 20V4M13 8l4-4 4 4"/></svg><span>Sortuj</span><select data-kv2-msort aria-label="Sortuj">' + opcje + '</select></label>' : '') +
        '<div class="kv2-seg kv2-seg--kol kv2-seg--kolm" role="group" aria-label="Liczba kolumn">' +
        [1, 2].map(function (n) { return '<button type="button" data-kv2-kolm="' + n + '" aria-label="' + n + (n === 1 ? ' kolumna' : ' kolumny') + '">' + ikKol(n) + '</button>'; }).join('') + '</div>';
      tgl.insertBefore(mb, tgl.firstChild);
    }
    document.querySelectorAll('[data-kv2-uklad]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.kv2Uklad === uklad())); });
    document.querySelectorAll('[data-kv2-kol]').forEach(function (b) { b.setAttribute('aria-pressed', String(Number(b.dataset.kv2Kol) === kolD())); b.hidden = Number(b.dataset.kv2Kol) === 5 && uklad() !== 'poziome'; });
    zbudujSort();
    kolory();
    grupyBoczne();
    document.querySelectorAll('[data-kv2-kolm]').forEach(function (b) { b.setAttribute('aria-pressed', String(Number(b.dataset.kv2Kolm) === kolM())); });
  }

  /* ---------- sortowanie w wygladzie kanwy: "Sortuj" + zwykla lista (komputer) ---------- */
  function zbudujSort() {
    var pasek = document.querySelector('.collection-wrapper .facets--horizontal');
    var sel = document.querySelector('.collection-wrapper select.sorting-filter__select');
    if (!pasek || !sel || pasek.querySelector('.kv2-sort')) return;
    var l = document.createElement('label');
    l.className = 'kv2-sort';
    l.innerHTML = '<span>Sortuj</span><select data-kv2-msort>' + Array.prototype.slice.call(sel.options).map(function (o) {
      return '<option value="' + o.value + '"' + (o.selected ? ' selected' : '') + '>' + o.textContent.trim() + '</option>';
    }).join('') + '</select>';
    pasek.appendChild(l);
  }

  /* ---------- kolory w filtrach jako kolka (nazwa w dymku) ---------- */
  var KOLORY = [
    [/czarn|black|antracyt/, '#1b1b1b'], [/bia[lł]|white|mleczn|opal/, '#f4f4f1'], [/z[lł]ot|gold/, '#c9a14a'], [/mosi[aą]dz|brass/, '#b5964f'],
    [/mied|copper|r[oó]żowe z[lł]oto|rose/, '#b46a3c'], [/chrom|chrome/, 'linear-gradient(135deg,#f2f2f2,#9a9a9a 50%,#e6e6e6)'], [/srebr|silver|nikiel|nickel|satyn/, '#c4c4c4'],
    [/grafit|graphite/, '#4a4a4a'], [/szar|gr[ae]y|beton/, '#9c9c9c'], [/dymion|smok/, '#77716b'], [/be[zż]|beige|kremow|cream|piask/, '#d9c6a5'], [/br[aą]z|brown|kawow|coffee|czekolad/, '#6b4a30'],
    [/drew|wood|d[aą]b|orzech|buk|bambus|rattan|wiklin/, '#c79a64'], [/ziel|green|oliw|sage/, '#7f9a73'], [/niebiesk|blue|granat|navy|turkus/, '#3d5f8c'],
    [/czerw|red|bordo|wino/, '#a8322d'], [/r[oó]ż|pink/, '#e3b1b6'], [/[zż][oó][lł]t|yellow|musztard/, '#e8c547'], [/pomara|orange|terrakot|terracot/, '#c8673b'],
    [/fiolet|purple|liliow/, '#7b5c9a'], [/przezroczy|transparent|bezbarw|clear/, 'repeating-conic-gradient(#e6e6e6 0 25%,#fff 0 50%) 0 0/8px 8px'],
    [/multi|kolorow|wielobarw/, 'conic-gradient(#c9a24a,#a8322d,#3d5f8c,#5d7a4e,#c9a24a)']
  ];
  function kolorTla(nazwa) {
    // kolory C (04.11.2026): filtr "Kolor" ma nazwy kolorow podstawowych - kolko z mapy (snippets/kl-kolory-mapa.liquid)
    var Mk = mapa();
    if (Mk && Mk.kropki && Mk.kropki[nazwa]) return Mk.kropki[nazwa];
    var t = (nazwa || '').toLowerCase();
    var czesci = t.split(/\s*(?:\+|\/|,| i )\s*/).filter(Boolean).slice(0, 2);
    var k = czesci.map(function (c) { for (var i = 0; i < KOLORY.length; i++) if (KOLORY[i][0].test(c)) return KOLORY[i][1]; return null; }).filter(Boolean);
    if (!k.length) return null;
    if (k.length === 2 && k[0].indexOf('gradient') < 0 && k[1].indexOf('gradient') < 0 && k[0] !== k[1]) return 'linear-gradient(135deg,' + k[0] + ' 50%,' + k[1] + ' 50%)';
    return k[0];
  }
  function kolory() {
    document.querySelectorAll('.collection-wrapper accordion-custom.facets__item[data-filter-param-name*="kolor"]').forEach(function (it) {
      it.classList.add('kv2-kolory');
      it.querySelectorAll('label.checkbox__label').forEach(function (lab) {
        if (lab.querySelector('.kv2-dot')) return;
        var txt = (lab.querySelector('.checkbox__label-text') || lab).textContent.trim();
        var tlo = kolorTla(txt);
        var d = document.createElement('span');
        d.className = 'kv2-dot' + (tlo ? '' : ' kv2-dot--brak');
        d.setAttribute('aria-hidden', 'true');
        if (tlo) d.style.background = tlo;
        lab.insertBefore(d, lab.querySelector('.checkbox__label-text') || lab.firstChild);
        lab.removeAttribute('title'); // runda 8: nazwa widoczna wprost na liscie
      });
    });
  }

  /* ---------- filtry z boku (runda 3): osobne karty, 5 pierwszych grup rozwinietych, 6 opcji + "Pokaz wszystkie" ---------- */
  var ROZWINIETE = 5, OPCJI = 6, OPCJI_KOLORY = 8, OPCJI_PIGULKI = 10; // runda 8: kolory jako lista -> 8 (bylo 14 kolek)
  var znaneBok = new WeakSet();
  var stanUsera = {}; // parametr filtra -> otwarty/zwiniety wybrany przez klienta
  function grupyBoczne() {
    var its = Array.prototype.slice.call(document.querySelectorAll('.collection-wrapper .facets--vertical accordion-custom.facets__item'));
    var bok = mqD.matches && !H.classList.contains('kv2-fh');
    its.forEach(function (it, i) {
      var d = it.querySelector('details');
      if (!d) return;
      var klucz = it.dataset.filterParamName || ('i' + i);
      if (bok && !znaneBok.has(d)) {
        znaneBok.add(d);
        d.open = klucz in stanUsera ? stanUsera[klucz] : i < ROZWINIETE;
      }
      var ul = it.querySelector('ul.facets__inputs-list');
      var tb = it.querySelector('.show-more__button');
      // runda 7: pigulki (np. Ilosc punktow swietlnych) = siatka 5 w rzedzie, wiec 10 opcji = 2 pelne rzedy
      var limit = it.classList.contains('kv2-kolory') ? OPCJI_KOLORY : (it.querySelector('ul.facets__inputs-list--grid') ? OPCJI_PIGULKI : OPCJI);
      it.style.setProperty('--kv2-limit', limit);
      var ile = ul ? ul.children.length : 0;
      var btn = it.querySelector('.kv2-wsz');
      if ((ile > limit || tb) && !btn) {
        btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'kv2-wsz';
        (it.querySelector('.facets__panel-content') || d).appendChild(btn);
      }
      if (btn) tekst(btn, it.classList.contains('kv2-wsz-on') ? 'Pokaż mniej' : 'Pokaż wszystkie');
      it.classList.toggle('kv2-limit-' + limit, true);
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.kv2-wsz');
    if (b) {
      e.preventDefault();
      var it = b.closest('.facets__item');
      var on = !it.classList.contains('kv2-wsz-on');
      it.classList.toggle('kv2-wsz-on', on);
      var tb = it.querySelector('.show-more__button');
      var sm = it.querySelector('show-more-component');
      if (tb && sm && (sm.dataset.expanded === 'true') !== on) tb.click(); // motyw dociaga reszte opcji (powyzej 10)
      b.textContent = on ? 'Pokaż mniej' : 'Pokaż wszystkie';
      return;
    }
    if (H.classList.contains('kv2-fh') || !mqD.matches) return;
    var sm2 = e.target.closest && e.target.closest('.facets--vertical details.facets__panel > summary');
    if (!sm2) return;
    var it2 = sm2.closest('.facets__item');
    stanUsera[it2.dataset.filterParamName || ''] = !sm2.parentElement.open;
  }, true);

  /* ---------- filtry poziome ---------- */
  var otwartyIdx = -1; // ktory panel byl otwarty przed przerysowaniem (filtrowanie)
  var NA_PASKU = 7; // ile filtrow widac, reszta pod "Wiecej filtrow"
  function panele() { return Array.prototype.slice.call(document.querySelectorAll('.collection-wrapper .facets--vertical details.facets__panel')); }
  var znane = new WeakSet();
  function urzadzPoziome() {
    var wr = document.querySelector('.collection-wrapper');
    if (!wr) return;
    var lista = wr.querySelector('.facets--vertical .facets__filters-wrapper');
    if (!lista) return;
    var items = Array.prototype.slice.call(lista.children).filter(function (e) { return e.classList.contains('facets__item'); });
    items.forEach(function (e, i) { e.classList.toggle('kv2-fh-nad', i >= NA_PASKU); });
    var btn = lista.querySelector('.kv2-fh-wiecej');
    if (items.length > NA_PASKU) {
      if (!btn) {
        btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'kv2-fh-wiecej';
        lista.appendChild(btn);
      }
      var wsz = wr.classList.contains('kv2-fh-wszystkie');
      tekst(btn, wsz ? 'Mniej filtrów' : 'Więcej filtrów (+' + (items.length - NA_PASKU) + ')');
      btn.setAttribute('aria-expanded', String(wsz));
    } else if (btn) btn.remove();
    // tylko NOWE panele (po przerysowaniu sekcji przez filtrowanie): zostaw otwarty ten, ktory klient mial otwarty
    var fh = H.classList.contains('kv2-fh');
    panele().forEach(function (d, i) {
      if (znane.has(d)) return;
      znane.add(d);
      if (!fh) return;
      if (i === otwartyIdx) { if (!d.open) d.open = true; }
      else if (d.open) d.open = false;
    });
  }
  function zamknijPanele() { otwartyIdx = -1; panele().forEach(function (d) { d.open = false; }); }
  document.addEventListener('click', function (e) {
    if (!H.classList.contains('kv2-fh')) return;
    var sm = e.target.closest && e.target.closest('.facets--vertical details.facets__panel > summary');
    if (!sm) return;
    var d = sm.parentElement;
    var ps = panele();
    var otworzy = !d.open;
    otwartyIdx = otworzy ? ps.indexOf(d) : -1;
    if (otworzy) ps.forEach(function (x) { if (x !== d && x.open) x.open = false; });
  }, true);
  document.addEventListener('pointerdown', function (e) {
    if (!H.classList.contains('kv2-fh')) return;
    if (e.target.closest && e.target.closest('.facets--vertical .facets__item')) return;
    if (otwartyIdx >= 0) zamknijPanele();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && H.classList.contains('kv2-fh') && otwartyIdx >= 0) zamknijPanele(); });

  /* ---------- kafel doradcy ---------- */
  function wstawDoradce() {
    var ul = document.querySelector('.collection-wrapper .product-grid');
    var tpl = document.getElementById('kv2-doradca-tpl');
    if (!ul || !tpl) return;
    var strona = new URLSearchParams(location.search).get('page');
    if (strona && strona !== '1') return;
    var karty = Array.prototype.slice.call(ul.querySelectorAll(':scope > li[data-product-id]'));
    var tel = mqM.matches;
    var n = tel ? kolM() * 3 : (mqD.matches ? kolD() : 2);
    var dor = ul.querySelector(':scope > [data-kv2-dor]');
    if (karty.length <= n) { if (dor) dor.remove(); return; }
    if (!dor) {
      dor = tpl.content.firstElementChild.cloneNode(true);
    }
    dor.classList.toggle('kv2-dor--pelny', tel);
    var po = karty[n - 1];
    if (po.nextElementSibling !== dor) po.after(dor);
    // kafel konfiguratorow: komputer po 4. rzedzie, telefon zaraz pod blokiem doradcy
    var ktpl = document.getElementById('kv2-konf-tpl');
    if (!ktpl) return;
    var konf = ul.querySelector(':scope > [data-kv2-konf]');
    if (!konf) konf = ktpl.content.firstElementChild.cloneNode(true);
    konf.classList.toggle('kv2-konf--pelny', tel);
    if (tel) { if (dor.nextElementSibling !== konf) dor.after(konf); return; }
    var nk = kolD() * 4 - 1; // -1: doradca zajmuje 1 miejsce w siatce
    if (karty.length <= nk) { konf.remove(); return; }
    if (karty[nk - 1].nextElementSibling !== konf) karty[nk - 1].after(konf);
  }
  document.addEventListener('click', function (e) {
    var chip = e.target.closest && e.target.closest('.kv2-dor .kv2-chip');
    if (!chip) return;
    var grupa = chip.closest('[data-kv2-q]');
    var on = chip.getAttribute('aria-pressed') !== 'true';
    grupa.querySelectorAll('.kv2-chip').forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
    chip.setAttribute('aria-pressed', String(on));
    var dor = chip.closest('.kv2-dor');
    var a = dor.querySelector('[data-kv2-dor-link]');
    var u = new URL(a.dataset.baza, location.origin);
    dor.querySelectorAll('[data-kv2-q]').forEach(function (q) {
      var w = q.querySelector('.kv2-chip[aria-pressed="true"]');
      if (w) u.searchParams.set(q.dataset.kv2Q, w.dataset.v);
    });
    a.href = u.pathname + u.search;
    // komputer: jedno pytanie na kaflu -> od razu do doradcy
    if (!dor.classList.contains('kv2-dor--pelny') && on) location.href = a.href;
  });

  /* ---------- podkategorie: strzalki ---------- */
  function strzalkiPodkategorii() {
    document.querySelectorAll('.kv2-cats').forEach(function (n) {
      var pas = n.querySelector('.kv2-cats__pas');
      if (!pas || n.dataset.kv2ok) return;
      n.dataset.kv2ok = '1';
      var l = n.querySelector('.kv2-cats__b--l'), p = n.querySelector('.kv2-cats__b--p');
      function odsw() {
        var max = pas.scrollWidth - pas.clientWidth - 2;
        l.hidden = !(mqD.matches && pas.scrollLeft > 2);
        p.hidden = !(mqD.matches && pas.scrollLeft < max);
      }
      [l, p].forEach(function (b) { b.addEventListener('click', function () { pas.scrollBy({ left: Number(b.dataset.kier) * pas.clientWidth * 0.8, behavior: 'smooth' }); }); });
      pas.addEventListener('scroll', odsw, { passive: true });
      window.addEventListener('resize', odsw);
      // KL perf 04.11.2026: pomiar (scrollWidth/offsetLeft) dopiero po ulozeniu strony przez przegladarke (ResizeObserver),
      // a nie w DOMContentLoaded - wczesniej wymuszal pelne przeliczenie ukladu (ok. 110 ms na telefonie)
      var pierwszy = true;
      function poUkladzie() {
        odsw();
        if (!pierwszy) return;
        pierwszy = false;
        var akt = pas.querySelector('.is-on');
        if (akt && akt.offsetLeft > pas.clientWidth - 160) pas.scrollLeft = akt.offsetLeft - 24;
      }
      if (window.ResizeObserver) new ResizeObserver(poUkladzie).observe(pas); else poUkladzie();
    });
  }

  /* ---------- Porownaj ---------- */
  var MAX = 4;
  function lista() { try { var a = JSON.parse(LS.get('kv2-por') || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function zapisz(a) { LS.set('kv2-por', JSON.stringify(a.slice(0, MAX))); }
  function przenies(el) { if (el && el.parentNode !== document.body) document.body.appendChild(el); return el; }
  function odswiezPorownanie() {
    if (!H.classList.contains('kl-kv2-por')) return;
    var a = lista();
    var hs = a.map(function (x) { return x.h; });
    document.querySelectorAll('[data-kv2-por]').forEach(function (c) { c.checked = hs.indexOf(c.dataset.kv2Por) >= 0; });
    var bar = przenies(document.querySelector('[data-kv2-cmpbar]'));
    przenies(document.querySelector('[data-kv2-cmp]'));
    if (!bar) return;
    bar.hidden = a.length === 0;
    tekst(bar.querySelector('[data-kv2-cmpt]'), 'Porównaj (' + a.length + '/' + MAX + ')');
    bar.querySelector('[data-kv2-cmpgo]').disabled = a.length < 2;
    html(bar.querySelector('[data-kv2-cmpmini]'), a.map(function (x) { return x.img ? '<img src="' + x.img + '" alt="" width="40" height="40">' : ''; }).join(''));
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.kv2-por')) e.stopPropagation(); // nie otwieraj karty produktu
  }, true);
  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('[data-kv2-msort]')) {
      var u = new URL(location.href);
      u.searchParams.set('sort_by', e.target.value);
      u.searchParams.delete('page');
      location.href = u.toString();
      return;
    }
    var c = e.target;
    if (!c.matches || !c.matches('[data-kv2-por]')) return;
    var a = lista().filter(function (x) { return x.h !== c.dataset.kv2Por; });
    if (c.checked) {
      if (a.length >= MAX) { c.checked = false; status('Możesz porównać maksymalnie ' + MAX + ' modele.'); alert('Możesz porównać maksymalnie ' + MAX + ' modele. Usuń jeden z paska na dole.'); return; }
      a.push({ h: c.dataset.kv2Por, t: c.dataset.kv2T || '', img: c.dataset.kv2Img || '' });
    }
    zapisz(a);
    odswiezPorownanie();
  });
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    if (t.closest('[data-kv2-cmpclr]')) { zapisz([]); odswiezPorownanie(); return; }
    if (t.closest('[data-kv2-cmpgo]')) { otworzPorownanie(); return; }
    if (t.closest('[data-kv2-mfiltry]')) { var fb = document.querySelector('.collection-wrapper .facets-toggle__button'); if (fb) fb.click(); return; }
    if (t.closest('[data-kv2-cmpx]')) { var d = document.querySelector('[data-kv2-cmp]'); if (d) d.close(); return; }
    var us = t.closest('[data-kv2-usun]');
    if (us) {
      zapisz(lista().filter(function (x) { return x.h !== us.dataset.kv2Usun; }));
      odswiezPorownanie();
      if (lista().length < 2) { document.querySelector('[data-kv2-cmp]').close(); } else otworzPorownanie();
      return;
    }
    var atc = t.closest('[data-kv2-atc]');
    if (atc) { e.preventDefault(); dodajDoKoszyka(atc); }
  });
  /* Perf 03.11.2026 (krok 5): okno porownania i "Dodaj do koszyka" z porownania w assets/kl-kv2-por.js,
     ladowane dopiero przy pierwszym "Porownaj" (adres w data-por na <script> kl-kv2.js, snippets/kl-kv2-gora.liquid). */
  var POR_URL = (document.currentScript && document.currentScript.getAttribute('data-por')) || '';
  var porMod = null;
  function modulPor() {
    if (window.klKv2Por) return Promise.resolve(window.klKv2Por);
    if (!porMod) porMod = new Promise(function (res, rej) {
      if (!POR_URL) { rej(new Error('brak kl-kv2-por.js')); return; }
      var sc = document.createElement('script');
      sc.src = POR_URL;
      sc.onload = function () { window.klKv2Por ? res(window.klKv2Por) : rej(new Error('kl-kv2-por.js')); };
      sc.onerror = function () { porMod = null; rej(new Error('kl-kv2-por.js')); };
      document.head.appendChild(sc);
    });
    return porMod;
  }
  window.klKv2Api = { lista: lista, przenies: przenies, status: function (t) { status(t); } };
  function otworzPorownanie() { modulPor().then(function (m) { m.otworz(); }, function (e) { status('Nie udało się otworzyć porównania. Odśwież stronę.'); }); }
  function dodajDoKoszyka(btn) { modulPor().then(function (m) { m.dodaj(btn); }); }

  /* ---------- runda 8: pasek wybranych filtrow nad siatka (snippets/kl-kv2-wybrane.liquid) ----------
     Pigulka = link do adresu bez danego filtra; przerysowanie bez przeladowania przez formularz filtrow motywu. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-kv2-wyb]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
    var f = document.querySelector('.collection-wrapper facets-form-component[form-style]') || document.querySelector('.collection-wrapper facets-form-component');
    if (!f || typeof f.updateFiltersByURL !== 'function') return; // bez JS motywu = zwykly link
    e.preventDefault();
    f.updateFiltersByURL(a.getAttribute('href'));
  });

  /* ---------- klik w przelaczniki ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-kv2-uklad],[data-kv2-kol],[data-kv2-kolm],.kv2-fh-wiecej');
    if (!t) return;
    if (t.classList.contains('kv2-fh-wiecej')) {
      var wr = document.querySelector('.collection-wrapper');
      wr.classList.toggle('kv2-fh-wszystkie');
      urzadzPoziome();
      return;
    }
    if (t.dataset.kv2Uklad) {
      var stary = uklad();
      LS.set('kv2-filtry', t.dataset.kv2Uklad);
      if (t.dataset.kv2Uklad === 'poziome') zamknijPanele();
      else panele().forEach(function (d) { d.open = true; });
    }
    if (t.dataset.kv2Kol) LS.set(uklad() === 'poziome' ? 'kv2-kol-gora' : 'kv2-kol-bok', t.dataset.kv2Kol);
    if (t.dataset.kv2Kolm) LS.set('kv2-kol-m', t.dataset.kv2Kolm);
    zastosujStan();
    zbudujPasek();
    wstawDoradce();
    urzadzPoziome();
    liczTop();
  });

  /* ---------- wyszukiwarka (runda 7): licznik w naglowku po filtrowaniu bez przeladowania ----------
     Motyw przerysowuje tylko sekcje wynikow, wiec liczbe bierzemy z jej "Pozycje: N". */
  function odmiana(n) {
    if (n === 1) return 'produkt';
    var r10 = n % 10, r100 = n % 100;
    return r10 >= 2 && r10 <= 4 && (r100 < 12 || r100 > 14) ? 'produkty' : 'produktów';
  }
  function licznikSzukaj() {
    var p = document.querySelector('[data-kv2-licznik]');
    var z = document.querySelector('.collection-wrapper .products-count-wrapper > span[title]');
    if (!p || !z) return;
    var m = (z.textContent || '').replace(/\s/g, '').match(/(\d+)\D*$/);
    if (!m) return;
    var n = Number(m[1]);
    var filtry = /(^|&|\?)filter\./.test(location.search);
    var klucz = n + '|' + filtry;
    if (p.dataset.kv2Stan === klucz) return;
    p.dataset.kv2Stan = klucz;
    p.innerHTML = n > 0
      ? (filtry ? 'Po filtrach: ' : 'Znaleźliśmy ') + '<b>' + n + '</b> ' + odmiana(n)
      : 'Brak produktów przy wybranych filtrach.';
  }

  /* ===================== runda 9 (03.11.2026) =====================
     A) Kolory podstawowe: "Kolor wiodacy" i "Kolor uzupelniajacy" pokazuja ~20 kolorow podstawowych zamiast ~180 odmian.
        Grupowanie TYLKO w motywie: mapa w snippets/kl-kolory-mapa.liquid (JSON), dane produktow i Search & Discovery bez zmian.
        Prawdziwe pola odmian (name=filter...) zostaja w formularzu (ukryte) - zaznaczenie koloru podstawowego zaznacza
        wszystkie jego dostepne odmiany i motyw robi JEDNO odswiezenie (Shopify laczy wartosci jednego filtra przez LUB).
     B) "Szukaj" w naglowku grupy filtrow (> PROG opcji): pole filtruje opcje tej grupy na zywo, bez serwera.
     Oba dzialaja na zywym DOM i na nowym drzewie przed morph (kl:przed-morph), wiec po filtrowaniu nic nie miga. */
  var MAPA;
  function mapa(root) {
    if (MAPA !== undefined) return MAPA;
    var el = (root && root.querySelector && root.querySelector('#kl-kolory-mapa')) || document.getElementById('kl-kolory-mapa');
    if (!el) return null;
    try {
      MAPA = JSON.parse(el.textContent);
      MAPA._re = (MAPA.reguly || []).map(function (r) { return [r[0], new RegExp(r[1])]; });
    } catch (e) { MAPA = null; }
    return MAPA;
  }
  function poleKoloru(it) {
    var M = mapa(it), pn = it.getAttribute('data-filter-param-name') || '';
    if (!M) return null;
    for (var i = 0; i < M.pola.length; i++) if (pn.slice(-M.pola[i].length) === M.pola[i]) return M.pola[i];
    return null;
  }
  function bazaKoloru(pole, v) {
    var M = mapa();
    if (M.mapa[pole] && M.mapa[pole][v]) return M.mapa[pole][v];
    for (var k in M.mapa) if (M.mapa[k][v]) return M.mapa[k][v];
    // wartosc spoza mapy (nowy import): pierwszy czlon przed + , / ; wygrywa wzorzec najwczesniej w tekscie
    var t = String(v).toLowerCase().split(/\s*[+,\/]\s*/)[0].trim(), best = null, poz = 1e9;
    M._re.forEach(function (r) { var m = t.match(r[1]); if (m && m.index < poz) { poz = m.index; best = r[0]; } });
    return best || 'Inne';
  }
  var bez = function (s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/ł/g, 'l'); };
  var escH = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };

  /* Perf 03.11.2026: w HTML sa tylko aktywne odmiany (pola formularza); pozostale w JSON <script data-kl-kolory>
     (snippets/list-filter.liquid): [indeks, wartosc, liczba, wylaczona]. Pola tworzymy dopiero, gdy trzeba je wyslac. */
  function daneKolorow(it) {
    var s = it.querySelector('script[data-kl-kolory]');
    if (!s) return null;
    var t = s.textContent || '{}';
    if (s.__klT === t) return s.__kl; // morph moze podmienic tekst w tym samym elemencie - cache po tresci
    s.__klT = t;
    try { s.__kl = JSON.parse(t); } catch (e) { s.__kl = null; }
    return s.__kl;
  }
  // wszystkie odmiany grupy: istniejace pola + wartosci z JSON (bez tych, ktore juz maja pole)
  function odmianyKoloru(it, surowa) {
    var w = [], jest = {};
    surowa.querySelectorAll('input.checkbox__input[name]').forEach(function (inp) {
      jest[inp.value] = 1;
      w.push({ v: inp.value, n: Number(inp.getAttribute('data-count')) || 0, chk: inp.checked, dis: inp.disabled, inp: inp });
    });
    var d = daneKolorow(it);
    if (d && d.w) d.w.forEach(function (x) { if (!jest[x[1]]) w.push({ i: x[0], v: x[1], n: x[2] || 0, chk: false, dis: !!x[3], inp: null }); });
    return { w: w, d: d };
  }
  // pole odmiany (ukryte, w surowej liscie) - ten sam znacznik co w list-filter.liquid
  function poleOdmiany(surowa, d, x) {
    var doc = surowa.ownerDocument, li = doc.createElement('li');
    li.className = 'facets__inputs-list-item';
    li.setAttribute('data-skip-node-update', 'true');
    li.innerHTML = '<div class="checkbox"><input type="checkbox" class="checkbox__input" name="' + escH(d.n) + '" value="' + escH(x.v) + '" id="' + escH(d.pre + x.i + d.suf) + '" data-count="' + x.n + '"' + (x.dis ? ' disabled' : '') + ' ref="facetInputs[]">' +
      '<label class="checkbox__label" for="' + escH(d.pre + x.i + d.suf) + '" role="checkbox"><span class="checkbox__label-text">' + escH(x.v) + '</span></label></div>';
    surowa.appendChild(li);
    x.inp = li.querySelector('input');
    return x.inp;
  }
  // bez mapy kolorow (awaria): pokaz wszystkie odmiany jako zwykla liste
  function rozwinSurowe(root) {
    root.querySelectorAll('accordion-custom.facets__item.kv2-grupuj').forEach(function (it) {
      var surowa = it.querySelector('ul.facets__inputs-list:not(.kv2-gr)');
      if (!surowa) return;
      it.classList.remove('kv2-grupuj');
      var o = odmianyKoloru(it, surowa);
      if (o.d) o.w.forEach(function (x) { if (!x.inp) poleOdmiany(surowa, o.d, x); });
    });
  }
  function grupujKolory(root) {
    if (!mapa(root)) { rozwinSurowe(root); return; }
    root.querySelectorAll('accordion-custom.facets__item.kv2-grupuj').forEach(function (it) {
      var pole = poleKoloru(it);
      var surowa = it.querySelector('ul.facets__inputs-list:not(.kv2-gr)');
      if (!pole || !surowa) return;
      var g = {};
      odmianyKoloru(it, surowa).w.forEach(function (x0) {
        var b = bazaKoloru(pole, x0.v);
        var x = g[b] || (g[b] = { n: 0, zazn: 0, dost: 0, wsz: 0 });
        x.wsz++;
        x.n += x0.n;
        if (x0.chk) x.zazn++;
        if (!x0.dis) x.dost++;
      });
      var bazy = Object.keys(g).sort(function (a, b) { return a === 'Inne' ? 1 : b === 'Inne' ? -1 : a.localeCompare(b, 'pl'); });
      var sig = bazy.map(function (b) { var x = g[b]; return b + ':' + x.n + ':' + x.zazn + ':' + x.dost; }).join('|');
      var ul = it.querySelector('ul.kv2-gr');
      it.classList.add('kv2-kolory');
      if (ul && ul.getAttribute('data-sig') === sig) return;
      if (!ul) {
        ul = surowa.ownerDocument.createElement('ul');
        ul.className = 'facets__inputs-list list-unstyled kv2-gr';
        surowa.parentNode.insertBefore(ul, surowa);
      }
      ul.setAttribute('data-sig', sig);
      var M = mapa();
      ul.innerHTML = bazy.map(function (b, i) {
        var x = g[b], id = 'kv2gr-' + pole + '-' + i, pelny = x.zazn > 0 && x.zazn >= x.dost, czesc = x.zazn > 0 && !pelny;
        var wyl = x.zazn === 0 && x.dost === 0;
        return '<li class="facets__inputs-list-item kv2-gr__li' + (czesc ? ' kv2-gr--czesc' : '') + '" data-kv2-b="' + escH(b) + '">' +
          '<div class="checkbox"><input type="checkbox" class="checkbox__input" id="' + id + '" data-kv2-baza="' + escH(b) + '"' +
          (pelny ? ' checked' : '') + (wyl ? ' disabled' : '') + (czesc ? ' data-kv2-czesc' : '') + '>' +
          '<label class="checkbox__label" for="' + id + '"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" class="icon-checkmark" aria-hidden="true"><use href="#kl-i-check"></use></svg>' +
          '<span class="kv2-dot" aria-hidden="true" style="background:' + escH(M.kropki[b] || '#ddd') + '"></span>' +
          '<span class="checkbox__label-text">' + escH(b) + (czesc ? ' <small>(część odmian)</small>' : '') + '</span>' +
          (x.n ? '<span class="kv2-gr__n">' + x.n + '</span>' : '') + '</label></div></li>';
      }).join('');
      ul.querySelectorAll('[data-kv2-czesc]').forEach(function (c) { c.indeterminate = true; });
      // wybrany kolor dalej niz 8. pozycja (np. Zloty) - rozwin liste, zeby zaznaczenie bylo widac
      var ost = -1;
      bazy.forEach(function (b, i) { if (g[b].zazn > 0) ost = i; });
      if (ost >= OPCJI_KOLORY) it.classList.add('kv2-wsz-on');
    });
  }
  // klik w kolor podstawowy: (od)zaznacz jego odmiany, zanim motyw (on:change w facet-inputs-component) zbierze formularz.
  // window + capture: motyw (component.js) lapie zdarzenia na document w fazie capture, wiec document bylby za pozno.
  window.addEventListener('change', function (e) {
    var c = e.target;
    if (!c.matches || !c.matches('input[data-kv2-baza]')) return;
    var it = c.closest('accordion-custom');
    var pole = it && poleKoloru(it);
    if (!pole) return;
    var wl = c.checked;
    c.indeterminate = false;
    var surowa = it.querySelector('ul.facets__inputs-list:not(.kv2-gr)');
    if (!surowa) return;
    var o = odmianyKoloru(it, surowa);
    o.w.forEach(function (x) {
      if (bazaKoloru(pole, x.v) !== c.dataset.kv2Baza) return;
      if (!x.inp) { if (!wl || x.dis || !o.d) return; poleOdmiany(surowa, o.d, x); }
      x.inp.checked = wl ? !x.inp.disabled : false;
    });
  }, true);

  /* pigulki "Wybrane filtry" nad siatka: jedna na kolor podstawowy, x zdejmuje wszystkie jego odmiany */
  function pigulkiKolorow(root) {
    var M = mapa(root);
    var pas = root.querySelector('.kv2-wyb');
    if (!M || !pas || pas.getAttribute('data-kv2-g')) return;
    pas.setAttribute('data-kv2-g', '1');
    var grupy = {};
    pas.querySelectorAll('a.kv2-wyb__p[data-p]').forEach(function (a) {
      var p = a.getAttribute('data-p'), pole = null;
      M.pola.forEach(function (x) { if (p.slice(-x.length) === x) pole = x; });
      if (!pole) return;
      var b = bazaKoloru(pole, a.getAttribute('data-v'));
      var k = p + '|' + b;
      if (!grupy[k]) grupy[k] = { p: p, b: b, f: a.getAttribute('data-f'), a: [] };
      grupy[k].a.push(a);
    });
    Object.keys(grupy).forEach(function (k) {
      var gr = grupy[k], usun = gr.a.map(function (a) { return a.getAttribute('data-v'); });
      var u = new URL(location.href);
      var zost = u.searchParams.getAll(gr.p).filter(function (v) { return usun.indexOf(v) < 0; });
      u.searchParams.delete(gr.p);
      zost.forEach(function (v) { u.searchParams.append(gr.p, v); });
      u.searchParams.delete('page');
      u.searchParams.delete('preview_theme_id');
      var a0 = gr.a[0];
      a0.setAttribute('href', u.pathname + u.search);
      var sp = a0.querySelector('span');
      if (sp) sp.innerHTML = escH(gr.f) + ': <b>' + escH(gr.b) + '</b>';
      gr.a.slice(1).forEach(function (a) { a.remove(); });
    });
  }

  /* "Szukaj" w grupie filtrow */
  var PROG = 6; // przycisk tylko gdy grupa ma wiecej niz 6 opcji (Dostepnosc, Cena i krotkie listy bez przycisku)
  var szuk = {}; // param -> { on, q }
  var LUPA = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>';
  function opcjeGrupy(it) {
    var gr = it.querySelector('ul.kv2-gr');
    if (gr) return gr.children.length;
    var ul = it.querySelector('ul.facets__inputs-list');
    if (!ul) return 0;
    var n = ul.querySelectorAll(':scope > li').length;
    var s = it.querySelector('script[data-kl-reszta]');
    if (s && !it.querySelector('show-more-component[data-kl-zbudowane]')) { try { n += (JSON.parse(s.textContent).w || []).length; } catch (e) {} }
    return n;
  }
  function dodajSzukanie(root) {
    root.querySelectorAll('accordion-custom.facets__item').forEach(function (it) {
      var pn = it.getAttribute('data-filter-param-name') || '';
      var sum = it.querySelector('summary.facets__summary');
      var panel = it.querySelector('.facets__panel-content');
      if (!sum || !panel || !it.querySelector('ul.facets__inputs-list')) return;
      if (opcjeGrupy(it) <= PROG) return;
      var nazwa = ((sum.querySelector('.facets__label') || sum).textContent || '').trim();
      var st = szuk[pn] || { on: false, q: '' };
      var btn = sum.querySelector('[data-kv2-szb]');
      if (!btn) {
        btn = sum.ownerDocument.createElement('button');
        btn.type = 'button';
        btn.className = 'kv2-szb';
        btn.setAttribute('data-kv2-szb', '');
        btn.innerHTML = LUPA + '<span>Szukaj</span>';
        btn.setAttribute('aria-label', 'Szukaj w filtrze ' + nazwa);
        var lab = sum.querySelector('.facets__label');
        if (lab && lab.nextSibling) sum.insertBefore(btn, lab.nextSibling); else sum.appendChild(btn);
      }
      btn.setAttribute('aria-expanded', String(!!st.on));
      var box = panel.querySelector(':scope > [data-kv2-szp]');
      if (!box) {
        box = panel.ownerDocument.createElement('div');
        box.className = 'kv2-szp';
        box.setAttribute('data-kv2-szp', '');
        box.innerHTML = LUPA + '<input type="search" class="kv2-szp__in" data-kv2-sz-in autocomplete="off" enterkeyhint="search" placeholder="Szukaj: ' + escH(nazwa.toLowerCase()) + '" aria-label="Szukaj w filtrze ' + escH(nazwa) + '">' +
          '<p class="kv2-szp__brak" data-kv2-szbrak hidden>Brak opcji</p>';
        panel.insertBefore(box, panel.firstChild);
      }
      if (st.on) box.removeAttribute('hidden'); else box.setAttribute('hidden', '');
      var inp = box.querySelector('[data-kv2-sz-in]');
      if (inp.getAttribute('value') !== st.q) inp.setAttribute('value', st.q);
      if (inp.value !== st.q && inp.ownerDocument !== document) inp.value = st.q;
      filtrujGrupe(it, st.on || H.classList.contains('kv2-fh') ? st.q : '');
    });
  }
  function filtrujGrupe(it, q) {
    var n = bez(q).trim();
    if (n && !it.querySelector('ul.kv2-gr')) {
      var sm = it.querySelector('show-more-component');
      if (sm && window.klFacety && sm.querySelector('script[data-kl-reszta]')) window.klFacety.zbuduj(sm);
    }
    var ul = it.querySelector('ul.kv2-gr') || it.querySelector('ul.facets__inputs-list');
    if (!ul) return;
    var traf = 0;
    ul.querySelectorAll(':scope > li').forEach(function (li) {
      var t = li.getAttribute('data-kv2-b') || (li.querySelector('.checkbox__label-text, .facets__pill-label, label') || li).textContent;
      var ok = !n || bez(t).indexOf(n) >= 0;
      if (ok) traf++;
      li.classList.toggle('kv2-nie', !ok);
    });
    it.classList.toggle('kv2-szuk-on', !!n);
    var brak = it.querySelector('[data-kv2-szbrak]');
    if (brak) { if (n && !traf) brak.removeAttribute('hidden'); else brak.setAttribute('hidden', ''); }
  }
  window.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-kv2-szb]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var it = b.closest('accordion-custom');
    var pn = it.getAttribute('data-filter-param-name') || '';
    var st = szuk[pn] || (szuk[pn] = { on: false, q: '' });
    st.on = !st.on;
    if (!st.on) st.q = '';
    var d = it.querySelector('details');
    if (st.on && d && !d.open) d.open = true;
    dodajSzukanie(it.parentNode || document);
    var box = it.querySelector('[data-kv2-szp]');
    var inp = box && box.querySelector('[data-kv2-sz-in]');
    if (inp) { inp.value = st.q; if (st.on) inp.focus(); }
    filtrujGrupe(it, st.on ? st.q : '');
  }, true);
  document.addEventListener('input', function (e) {
    if (!e.target.matches || !e.target.matches('[data-kv2-sz-in]')) return;
    var it = e.target.closest('accordion-custom');
    var pn = it.getAttribute('data-filter-param-name') || '';
    var st = szuk[pn] || (szuk[pn] = { on: true, q: '' });
    st.q = e.target.value;
    if (H.classList.contains('kv2-fh')) st.on = !!st.q;
    filtrujGrupe(it, st.q);
  });
  // pole szukania lezy w formularzu filtrow: Enter nie wysyla formularza, change nie odswieza filtrow
  window.addEventListener('keydown', function (e) {
    if (e.target.matches && e.target.matches('[data-kv2-sz-in]') && e.key === 'Enter') { e.preventDefault(); e.stopPropagation(); }
  }, true);
  window.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('[data-kv2-sz-in]')) e.stopPropagation();
  }, true);

  // zwiniecie grupy (z boku, panel u gory, sekcja w szufladzie): schowaj pole i wyczysc fraze - lista wraca do normalnej
  window.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || d.tagName !== 'DETAILS' || d.open) return;
    var it = d.closest('accordion-custom.facets__item');
    if (!it) return;
    var pn = it.getAttribute('data-filter-param-name') || '';
    if (!szuk[pn] || (!szuk[pn].on && !szuk[pn].q)) return;
    szuk[pn] = { on: false, q: '' };
    var inp = it.querySelector('[data-kv2-sz-in]');
    if (inp) inp.value = '';
    dodajSzukanie(it.parentNode || document);
  }, true);

  function runda9(root) { grupujKolory(root); pigulkiKolorow(root); dodajSzukanie(root); }
  document.addEventListener('kl:przed-morph', function (e) {
    var nowy = e.detail && e.detail.nowy;
    if (nowy) { try { runda9(nowy); } catch (err) {} }
  });

  /* ---------- start + po przerysowaniu ---------- */
  var czeka = false;
  function wszystko() {
    czeka = false;
    zastosujStan();
    grupujKolory(document); // runda 9: przed zbudujPasek (grupyBoczne liczy wiersze kolorow podstawowych)
    zbudujPasek();
    pigulkiKolorow(document);
    dodajSzukanie(document);
    urzadzPoziome();
    wstawDoradce();
    strzalkiPodkategorii();
    odswiezPorownanie();
    licznikSzukaj();
  }
  function zaplanuj() { if (!czeka) { czeka = true; requestAnimationFrame(wszystko); } }
  function start() {
    if (H.classList.contains('kv2-fh')) zamknijPanele();
    wszystko();
    liczTop();
    var cel = document.querySelector('main') || document.body;
    new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) {
        var n = ms[i].target;
        if (n.closest && (n.closest('.kv2-tb') || n.closest('.kv2-cmp') || n.closest('.kv2-cmpbar'))) continue;
        zaplanuj();
        return;
      }
    }).observe(cel, { childList: true, subtree: true });
    mqD.addEventListener('change', function () { wszystko(); liczTop(); });
    mqM.addEventListener('change', wszystko);
    window.addEventListener('resize', liczTopRaf, { passive: true });
    window.addEventListener('scroll', liczTopRaf, { passive: true });
    sledzNaglowek();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
